import {
  UseQueryResult,
  useQuery,
  keepPreviousData,
} from '@tanstack/react-query';
import { Order } from 'tabs/Accounting/types';
import { searchOrders } from 'tabs/MerchantOrders/api';
import {
  MerchantOrderFilters,
  SortOptions,
  OrderSearchResponse,
} from 'tabs/MerchantOrders/types';

const queryKeys = {
  all: () => ['merchantOrders'] as const,
  getMerchantOrders: (
    filters: MerchantOrderFilters,
    pagination: { size: number; page: number },
    sortOptions?: SortOptions
  ) =>
    [
      ...queryKeys.all(),
      'getMerchantOrders',
      filters,
      pagination,
      sortOptions,
    ] as const,
};

export interface MerchantOrdersApi {
  getMerchantOrders: (
    filters: MerchantOrderFilters,
    pagination: { size: number; page: number },
    sortOptions: SortOptions
  ) => UseQueryResult<Order[]>;
}

const getMerchantOrdersFn = async (
  filters: MerchantOrderFilters,
  pagination: { size: number; page: number },
  sortOptions?: SortOptions
): Promise<OrderSearchResponse> => {
  return searchOrders({
    pagination,
    filters,
    sortOptions,
  });
};

export const useMerchantOrdersApi = () => {
  const useGetMerchantOrders = (
    filters: MerchantOrderFilters,
    pagination: { size: number; page: number },
    sortOptions?: SortOptions
  ) => {
    return useQuery({
      queryKey: queryKeys.getMerchantOrders(filters, pagination, sortOptions),
      queryFn: () => getMerchantOrdersFn(filters, pagination, sortOptions),
      enabled: true,
      staleTime: 1000 * 60 * 1,
      placeholderData: keepPreviousData,
    });
  };

  return {
    useGetMerchantOrders,
  };
};
